import { Box, Text, VStack } from '@elkaso-app/web-design';
import React from 'react';

export interface ILocationCell {
  region?: string;
  country?: string;
}

export const LocationCell: React.FC<ILocationCell> = ({ region, country }) => {
  return (
    <Box py={2} px={1} minW='180px'>
      <VStack align='start' spacing={2}>
        {region && (
          <Text fontWeight='semibold' fontSize='md' color='gray.800' lineHeight='1.3' wordBreak='break-word'>
            {region}
          </Text>
        )}
        {country && (
          <Text fontSize='sm' color='gray.600' lineHeight='1.3' wordBreak='break-word'>
            {country}
          </Text>
        )}
        {!region && !country && (
          <Text fontSize='sm' color='gray.400' fontStyle='italic'>
            Location not specified
          </Text>
        )}
      </VStack>
    </Box>
  );
};
